var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDisposable(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.001 512.001",
    style: {
      enableBackground: "new 0 0 512.001 512.001"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FBAE2E"
    },
    d: "M247.765,216.1c-1.053-1.136-2.532-1.783-4.083-1.783H34.435c-1.55,0-3.03,0.646-4.083,1.783 c-1.053,1.136-1.585,2.661-1.466,4.206l21.7,284.129c0.221,2.902,2.64,5.141,5.549,5.141H79.01h47.439c0.008,0,0.016,0,0.022,0 h98.347V391.698l0,0c2.909,0,8.312,33.883,8.535,30.983l15.879-202.374C249.35,218.76,248.819,217.237,247.765,216.1z  M79.009,434.783c-4.169-6.156-6.61-13.567-6.61-21.524c0-7.982,2.439-15.405,6.61-21.562V434.783z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#202020"
    },
    d: "M97.931,434.783v-43.086c-4.172,6.157-6.61,13.58-6.61,21.562 C91.321,421.216,93.762,428.627,97.931,434.783z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#202020"
    },
    d: "M69.507,504.435l-21.7-284.129c-0.118-1.546,0.413-3.07,1.466-4.206 c1.053-1.136,2.532-1.783,4.083-1.783H34.434c-1.55,0-3.03,0.646-4.083,1.783c-1.053,1.136-1.585,2.661-1.466,4.206l21.7,284.129 c0.222,2.902,2.64,5.141,5.549,5.141h18.922C72.147,509.578,69.729,507.337,69.507,504.435z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DCE0E2"
    },
    d: "M239.888,8.826l-17.756-6.101c-1.396-0.481-2.925-0.386-4.252,0.263 c-1.327,0.648-2.341,1.795-2.82,3.191l-43.263,125.93c-0.584,1.701-0.312,3.578,0.733,5.042c1.044,1.463,2.731,2.332,4.529,2.332 h19.853c2.376,0,4.491-1.509,5.264-3.757l41.166-119.828C244.341,12.99,242.795,9.825,239.888,8.826z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7BF6D"
    },
    d: "M250.559,136.144H27.557c-3.074,0-5.565,2.491-5.565,5.565v41.722c0,3.074,2.491,5.565,5.565,5.565 h223.003c3.073,0,5.565-2.491,5.565-5.565v-41.722C256.125,138.635,253.633,136.144,250.559,136.144z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.15,
      fill: "#202020",
      enableBackground: "new"
    },
    d: "M40.913,183.431v-41.722c0-3.074,2.491-5.565,5.565-5.565 H27.557c-3.074,0-5.565,2.491-5.565,5.565v41.722c0,3.074,2.491,5.565,5.565,5.565h18.922 C43.404,188.997,40.913,186.506,40.913,183.431z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F7BF6D"
    },
    points: "30.488,241.305 247.628,241.305 249.689,214.317 28.428,214.317  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F7BF6D"
    },
    points: "30.488,241.305 247.628,241.305 251.718,193.271 26.605,193.271  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E95353"
    },
    d: "M473.459,374.72H110.937c-21.285,0-38.538,17.257-38.538,38.54c0,21.278,17.253,38.536,38.538,38.536 h5.314h351.898h2.283h3.029c21.283,0,38.541-17.258,38.541-38.536C512,391.977,494.742,374.72,473.459,374.72z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8C5549"
    },
    d: "M278.116,190.263c0-9.961-8.076-18.039-18.039-18.039H18.04c-9.964,0-18.04,8.078-18.04,18.039v6.013 c0,9.964,8.076,18.041,18.04,18.041h242.037c9.963,0,18.039-8.077,18.039-18.041V190.263z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.15,
      fill: "#202020",
      enableBackground: "new"
    },
    points: "28.428,214.317 30.488,241.305 49.411,241.305  47.35,214.317  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.15,
      fill: "#202020",
      enableBackground: "new"
    },
    d: "M18.922,196.276v-6.013c0-9.961,8.076-18.039,18.04-18.039 H18.04c-9.964,0-18.04,8.078-18.04,18.039v6.013c0,9.964,8.076,18.041,18.04,18.041h18.922 C26.998,214.317,18.922,206.24,18.922,196.276z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F96969"
    },
    d: "M168.222,374.72l-8.05,8.259c-3.219,3.302-3.151,8.587,0.151,11.805 c1.623,1.582,3.725,2.37,5.826,2.37c2.172,0,4.342-0.843,5.978-2.521l17.665-18.124c0.533-0.547,0.967-1.152,1.32-1.789H168.222z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F96969"
    },
    d: "M224.397,374.72l-8.05,8.26c-3.219,3.301-3.151,8.586,0.151,11.804 c1.623,1.582,3.725,2.37,5.826,2.37c2.172,0,4.342-0.843,5.978-2.522l17.665-18.124c0.533-0.547,0.966-1.151,1.32-1.788 L224.397,374.72L224.397,374.72z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F96969"
    },
    d: "M280.573,374.72l-8.049,8.26c-3.218,3.301-3.15,8.586,0.152,11.804 c1.624,1.582,3.726,2.37,5.826,2.37c2.172,0,4.343-0.843,5.978-2.522l17.665-18.124c0.533-0.547,0.965-1.151,1.32-1.788 L280.573,374.72L280.573,374.72z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F96969"
    },
    d: "M336.745,374.72l-8.048,8.259c-3.218,3.302-3.15,8.587,0.151,11.805 c1.623,1.582,3.725,2.37,5.826,2.37c2.173,0,4.342-0.843,5.979-2.521l17.665-18.124c0.533-0.547,0.966-1.152,1.32-1.789H336.745z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F96969"
    },
    d: "M392.921,374.72l-8.048,8.259c-3.218,3.302-3.15,8.587,0.151,11.805 c1.623,1.582,3.725,2.37,5.826,2.37c2.173,0,4.342-0.843,5.979-2.521l17.665-18.124c0.533-0.547,0.966-1.152,1.32-1.789H392.921z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#202020"
    },
    d: "M91.321,413.259c0-21.284,17.253-38.54,38.538-38.54h-18.922c-21.285,0-38.538,17.257-38.538,38.54 c0,21.278,17.253,38.536,38.538,38.536h5.314c0.03-0.81,0.092-1.614,0.171-2.412C101.764,443.928,91.321,429.813,91.321,413.259z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7BD63"
    },
    d: "M428.113,413.257H156.286c-22.133,0-40.074,17.94-40.074,40.074v7.103v1.967v7.105 c0,22.133,17.941,40.073,40.074,40.073h221.418h27.454h22.957c22.131,0,40.074-17.94,40.074-40.073v-7.105v-1.967v-7.103 C468.187,431.197,450.244,413.257,428.113,413.257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.15,
      fill: "#202020",
      enableBackground: "new"
    },
    d: "M135.135,469.505V462.4v-1.967v-7.103 c0-22.134,17.941-40.074,40.073-40.074h-18.923c-22.133,0-40.074,17.94-40.074,40.074v7.103v1.967v7.105 c0,22.133,17.941,40.073,40.074,40.073h18.923C153.076,509.578,135.135,491.636,135.135,469.505z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisposable);
export default __webpack_public_path__ + "static/media/disposable.803d142acf79533f7c9562c60254becc.svg";
export { ForwardRef as ReactComponent };